// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1fGaj","footer":"styles_footer__1e0WY"};